import { Link } from '@tanstack/react-router';
import { t } from '@lingui/core/macro';
import { Note } from '../../types/api';
import { formatRelativeTime } from '../../utils/dateUtils';
import Icon from '../ui/Icon';

interface NoteRowProps {
  note: Note;
}

function NoteRow({ note }: NoteRowProps) {
  const handleHighlightClick = () => {
    // Navigate to the specific highlight in the article
    // The note has bookmark_id and highlight_id for navigation
  };

  // Extract domain from URL if available
  const getDomain = (url?: string) => {
    if (!url) return t`Article`;
    try {
      return new URL(url).hostname.replace('www.', '');
    } catch {
      return t`Article`;
    }
  };

  return (
    <label className="bookmark-row" onClick={handleHighlightClick} data-testid="note-row">
      <div className="bookmark-content border-default flex border-b pl-5 md:pl-8">
        {/* Main content row */}
        <div className="flex-1">
          <Link
            to="/read/$bookmarkId/$highlightId"
            params={{ bookmarkId: note.bookmark_id, highlightId: note.id }}
            className="text-copy-secondary line-clamp-1 text-sm leading-tight font-medium"
            title={note.bookmark_title || note.text}
          >
            {note.bookmark_title || note.text}
          </Link>
          {/* Meta information */}
          <div className="bookmark-meta text-copy-secondary text-copy-muted mt-1 text-xs">
            <span className="host">
              <Link
                to="/read/$bookmarkId/$highlightId"
                params={{ bookmarkId: note.bookmark_id, highlightId: note.id }}
              >
                {getDomain(note.bookmark_url)}
              </Link>
            </span>
            <span className="meta_date">
              &middot; {formatRelativeTime(note.bookmark_time || note.time)}
            </span>
          </div>

          {/* Highlight text */}
          <div className="bookmark-description mt-2 max-w-[70ch]">
            <Link
              to="/read/$bookmarkId/$highlightId"
              params={{ bookmarkId: note.bookmark_id, highlightId: note.id }}
              className="line-clamp-3 text-lg leading-snug font-medium"
              onClick={handleHighlightClick}
            >
              {note.text}
            </Link>
          </div>

          {/* Note content */}
          {note.note && (
            <div className="mt-3 max-w-[70ch]">
              <div className="flex items-start gap-1">
                <Icon
                  name="note-filled"
                  className="text-link flex-shrink-0 translate-y-[-1px]"
                  data-testid="icon-note"
                />
                <div className="text-sm leading-snug">{note.note}</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </label>
  );
}

export default NoteRow;
